export const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
// new RegExp(
//   '^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]+$'
// );
